/**
 * Site configuration — edit this file to personalize the portfolio.
 * The Nostr feed and posting permissions are derived from `ownerPubkey`.
 */
export const SITE = {
  name: 'MK Fain',
  role: 'Open Source Developer',
  tagline: 'Building sovereign tools on Bitcoin & Nostr',
  location: 'Nairobi, Kenya',
  timezone: 'EAT (UTC+3)',

  /** The site owner's Nostr identity. The public feed shows this pubkey's notes,
   *  and the composer appears when logged in as this pubkey. */
  ownerPubkey: '932614571afcbad4d17a191ee281e39eebbb41b93fac8fd87829622aeb112f4d',
  npub: 'npub1jvnpg4c6ljadf5t6ry0w9q0rnm4mksde87kglkrc993z46c39axsgq89sc',
  nip05: 'mk@ditto.pub',
  lightningAddress: 'mkfain@cash.app',

  /** External links */
  nostrProfileUrl: 'https://njump.me/npub1jvnpg4c6ljadf5t6ry0w9q0rnm4mksde87kglkrc993z46c39axsgq89sc',

  about: [
    "I'm a software developer based in Nairobi, Kenya, contributing to open source projects in the Bitcoin and Nostr ecosystems. I care about tools that give people sovereignty over their money, their speech, and their data.",
    "My work spans protocol development, client applications, and developer tooling — from Lightning payment flows to relay infrastructure. I believe the future of the internet is open, permissionless, and built in public.",
    "When I'm not writing code, you'll find me mentoring developers in Nairobi's tech community, reading, or tending to my plants.",
  ],

  stack: [
    'Bitcoin',
    'Lightning',
    'Nostr',
    'TypeScript',
    'React',
    'Rust',
    'Go',
    'Node.js',
  ],

  projects: [
    {
      name: 'Mwangaza',
      description:
        'Lightning-native crowdfunding for East African creators. Non-custodial pledges, zap goals, and transparent payouts — no platform taking a cut.',
      tags: ['Lightning', 'Nostr', 'React'],
      link: 'https://github.com',
      status: 'Maintained',
    },
    {
      name: 'Relay Kit',
      description:
        'Opinionated tooling for running community Nostr relays: config generation, monitoring hooks, and one-command deploys for African relay operators.',
      tags: ['Nostr', 'Go', 'Infrastructure'],
      link: 'https://github.com',
      status: 'Maintained',
    },
    {
      name: 'Sats POS',
      description:
        'A point-of-sale app that lets Nairobi merchants accept Lightning payments in seconds, with automatic KES conversion display and offline queueing.',
      tags: ['Bitcoin', 'Lightning', 'LNURL'],
      link: 'https://github.com',
      status: 'Beta',
    },
    {
      name: 'Ndev Docs',
      description:
        'A Swahili-first documentation project translating Bitcoin and Nostr developer guides, lowering the barrier for the next wave of builders.',
      tags: ['Docs', 'Community', 'Education'],
      link: 'https://github.com',
      status: 'Ongoing',
    },
  ],

  contributions: [
    'Nostrify',
    'nostr-tools',
    'Ditto',
    'bitcoinjs-lib',
    'LDK',
  ],
} as const;
